export default __webpack_public_path__ + "static/media/Javascript-icon.76536eb2.png";